import {makeStyles, Table, TableBody, TableCell, TableHead, TableRow} from "@material-ui/core";
import PropTypes from "prop-types";
import React from "react";
import Tr from "translations/Translations";
import OfferChoiceResultFilesTableRow from "./OfferChoiceResultFilesTableRow";

const useStyles = makeStyles(theme => ({
    statusColumn: theme.components.table.emailColumn,
    dateTimeColumn: {
        width: 248
    },
    buttonColumn: theme.components.table.buttonColumn,
}));

function OfferChoiceResultFilesTable(
    {
        demandId,
        editable,
        offerChoiceResultItem,
        files,
        setFiles,
        showShare,
        canDownloadFile
    }) {

    const classes = useStyles();

    const onDeleteFile = (fileToDelete) => {
        setFiles(state => state.filter(f => f.identity !== fileToDelete.identity));
    }

    const onUpdateFile = (fileToUpdate) => {
        setFiles(state => state.map(f => f.identity === fileToUpdate.identity ? fileToUpdate : f));
    }

    if (!files) return null;
    return (<Table className={classes.table}>
        <TableHead>
            <TableRow className={classes.headRow}>
                <TableCell>{Tr("name")}</TableCell>
                <TableCell className={classes.statusColumn}>{Tr("status")}</TableCell>
                <TableCell className={classes.dateTimeColumn}>{Tr("publish_data")}</TableCell>
                <TableCell className={classes.buttonColumn}></TableCell>
                {showShare && <TableCell className={classes.buttonColumn}></TableCell>}
                <TableCell className={classes.buttonColumn}></TableCell>
                <TableCell className={classes.buttonColumn}></TableCell>
                <TableCell className={classes.buttonColumn}></TableCell>
            </TableRow>
        </TableHead>
        <TableBody>
            {files.map(file => (
                <OfferChoiceResultFilesTableRow
                    key={file.identity}
                    demandId={demandId}
                    file={file}
                    offerChoiceResultItem={offerChoiceResultItem}
                    editable={editable}
                    onDeleteFile={onDeleteFile}
                    onUpdateFile={onUpdateFile}
                    showShare={showShare}
                    canDownloadFile={canDownloadFile}
                />
            ))}
        </TableBody>
    </Table>)


}

OfferChoiceResultFilesTable.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
    offerChoiceResultItem: PropTypes.object.isRequired,
    files: PropTypes.array.isRequired,
    setFiles: PropTypes.func.isRequired
}

export default OfferChoiceResultFilesTable;

